import type React from "react"
import { X } from "lucide-react"

import { FORM_INPUT_CLASS, FORM_LABEL_CLASS } from "./CreateJobFields"

type CreateJobTextModalProps = {
    title: string
    label: string
    value: string
    placeholder: string
    closeLabel: string
    onChange: (value: string) => void
    onClose: () => void
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export const CreateJobTextModal = ({
    title,
    label,
    value,
    placeholder,
    closeLabel,
    onChange,
    onClose,
    onSubmit,
}: CreateJobTextModalProps) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
        <form onSubmit={onSubmit} className="w-full max-w-md rounded-md bg-white p-6 shadow-xl">
            <div className="mb-5 flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-800">{title}</h3>
                <button
                    type="button"
                    onClick={onClose}
                    className="rounded-md p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                    aria-label={closeLabel}
                >
                    <X className="h-5 w-5" />
                </button>
            </div>
            <label className={`mb-2 block ${FORM_LABEL_CLASS}`}>{label}</label>
            <input
                type="text"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                placeholder={placeholder}
                className={`mb-6 w-full rounded-md bg-[#F9F9F9] px-4 py-3 ${FORM_INPUT_CLASS} text-gray-800 focus:outline-none focus:ring-2 focus:ring-lime-400`}
                autoFocus
            />
            <div className="flex justify-end gap-3">
                <button
                    type="button"
                    onClick={onClose}
                    className="rounded-md px-4 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn-cta rounded-md px-4 py-2 text-sm font-semibold"
                >
                    Add
                </button>
            </div>
        </form>
    </div>
)
